import { createSlice } from '@reduxjs/toolkit';
import { isMobileWeb } from '@global/screens';

const slice = createSlice({
  name: 'global',
  initialState: {
    showAlert: {
      // handling show or hide alert popup
      show: false,
      title: '',
      description: '',
      descriptionComponent: null,
      onCallback: null,
      onCallbackCancel: null,
      isConfirm: true,
      others: null,
      internet: false,
      testID: '',
    },
    showDiscard: {
      // handling show or hide discard popup
      show: false,
      title: '',
      description: '',
      buttons: [],
    },
    popupImage: {
      // handling show or hide popup image
      isModal: false,
      url: null,
      text: null,
      onEdit: false,
      disableCDN: false,
      isMultiple: false,
      allImage: [],
      noArrow: false,
    },
    tempData: null, // store temporary data for specific condition
    country: 'indonesia',
    can_leave: true,
    promotionTypes: {
      trade_promo: 'Trade Promo',
      // customer_promo: 'Customer Promo'
    },
    promotionModels: {
      regular_discount: 'Regular Discount',
      extra_discount: 'Extra Discount',
      buy_x_get_x_and_buy_x_get_y: 'Buy X Get X and Buy X Get Y',
      cash_before_delivery: 'Cash Before Delivery',
    },
    route: {
      current: '',
      previous: '',
    },
    skpGenerateStatus: false,
    showNetworkLogger: true,
    app_version: '',
    forceUpdate: {
      show: false,
      data: null,
    },
  },
  reducers: {
    setTempData: (state, action) => {
      state.tempData = action.payload;
    },
    setShowNetworkLogger: (state, action) => {
      state.showNetworkLogger = action.payload;
    },
    setSkpGenerateStatus: (state, action) => {
      state.skpGenerateStatus = action.payload;
    },
    showAlert: (state, action) => {
      state.showAlert = {
        show: action.payload.show,
        title: action.payload.title,
        others: action.payload.others,
        description: action.payload.description,
        descriptionComponent: action.payload.descriptionComponent,
        onCallback: action.payload.onCallback
          ? action.payload.onCallback
          : null,
        onCallbackCancel: action.payload.onCallbackCancel
          ? action.payload.onCallbackCancel
          : null,
        isConfirm: action.payload.isConfirm == false ? false : true,
        internet: action.payload.internet || false,
        testID: action.payload.testID || '',
      };
    },
    hideAlert: (state, action) => {
      state.showAlert = {
        show: false,
        title: '',
        description: '',
        descriptionComponent: null,
        onCallback: null,
        onCallbackCancel: null,
        isConfirm: true,
        internet: false,
        testID: '',
      };
    },
    showDiscard: (state, action) => {
      state.showDiscard = {
        show: action.payload.show,
        title: action.payload.title,
        description: action.payload.description,
        buttons: action.payload.buttons ? action.payload.buttons : [],
      };
    },
    hideDiscard: (state, action) => {
      state.showDiscard = {
        show: false,
        title: '',
        description: '',
        buttons: [],
      };
    },
    showImage: (state, action) => {
      state.popupImage = {
        noArrow: action.payload.noArrow ? true : false,
        isMultiple: action.payload.isMultiple ? true : false,
        allImage: action.payload?.allImage?.length
          ? action.payload?.allImage
          : [],
        isModal: action.payload.isModal ? true : false,
        url: action.payload.url ? action.payload.url : null,
        text: action.payload.text ? action.payload.text : null,
        onEdit: action.payload.onEdit ? action.payload.onEdit : false,
        disableCDN: action.payload.disableCDN
          ? action.payload.disableCDN
          : false,
      };
    },
    hideImage: (state, action) => {
      state.popupImage = {
        isMultiple: false,
        allImage: [],
        isModal: false,
        url: null,
        text: null,
        onEdit: false,
      };
    },
    setCanLeave: (state, action) => {
      state.can_leave = action.payload;
    },
    setAppVersion: (state, action) => {
      state.app_version = action.payload;
    },
    showForceUpdate: (state, action) => {
      state.forceUpdate = {
        show: true,
        data: action.payload,
      };
    },
    hideForceUpdate: (state) => {
      state.forceUpdate = {
        show: false,
        data: null,
      };
    },
    setRoute: {
      reducer: (state, action) => {
        state.route = { ...action.payload };
      },
      prepare: (payload) => {
        if (isMobileWeb && document && document.body.style) {
          if (payload?.options?.hideScroll) {
            document.body.style.overflowY = 'hidden';
          } else {
            document.body.style.overflowY = 'auto';
          }
        }
        return { payload };
      },
    },
  },
});

export const {
  setTempData,
  setSkpGenerateStatus,
  setShowNetworkLogger,
  showAlert,
  hideAlert,
  showDiscard,
  hideDiscard,
  showImage,
  hideImage,
  setCanLeave,
  setRoute,
  setAppVersion,
  showForceUpdate,
  hideForceUpdate,
  setFilterActivityExport,
  setFilterActivityDelete,
} = slice.actions;
export default slice.reducer;
